import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'state'
import type { State, AccountState } from '../types'
import { fetchAccountData, fetchAccountFailed } from '.'

export const useAccount = (): AccountState => {
  const dispatch = useAppDispatch()
  const account = useSelector((state: State) => state.account)

  useEffect(() => {
    if (!account.isAuthenticated) {
      const accessToken = localStorage.getItem('bba-token')
      if (accessToken) {
        dispatch(fetchAccountData(accessToken))
      } else {
        dispatch(fetchAccountFailed())
      }
    }
  }, [dispatch, account.isAuthenticated])

  return account
}
